"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Breakfast;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Breakfast(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Facilities"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "breakfast"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M41.248,36.236a2.5,2.5,0,1,0,3.932-3.09c-.1-.124-2.354-3.081.632-6.755,5.282-6.5-.49-17.149-.738-17.6A2.5,2.5,0,0,0,40.693,11.2c1.234,2.253,3.861,8.807,1.239,12.034A10.383,10.383,0,0,0,41.248,36.236Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M35.3,37.191a2.5,2.5,0,0,0,2.152-3.767c-.024-.043-2.471-4.3.192-7.793A2.5,2.5,0,0,0,33.662,22.6c-4.676,6.137-.7,13.065-.524,13.357A2.5,2.5,0,0,0,35.3,37.191Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M52.085,37.191a2.5,2.5,0,0,0,2.153-3.767c-.025-.043-2.472-4.3.191-7.793A2.5,2.5,0,0,0,50.452,22.6c-4.676,6.137-.7,13.065-.523,13.357A2.5,2.5,0,0,0,52.085,37.191Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M73.518,47.526H67.894V43.909a2.5,2.5,0,0,0-2.5-2.5H20.949a2.5,2.5,0,0,0-2.5,2.5v29.63a13.375,13.375,0,0,0,10.123,12.95v1.535A4.481,4.481,0,0,0,33.048,92.5H53.3a4.481,4.481,0,0,0,4.476-4.476V86.489a13.375,13.375,0,0,0,10.123-12.95V69.594h5.623a8.044,8.044,0,0,0,8.034-8.034v-6A8.044,8.044,0,0,0,73.518,47.526ZM33.572,87.5v-.6h19.2v.6ZM62.894,73.539A8.374,8.374,0,0,1,54.529,81.9H31.813a8.373,8.373,0,0,1-8.364-8.364V46.409H62.894ZM76.551,61.56a3.039,3.039,0,0,1-3.034,3.034H67.894V52.526h5.624a3.038,3.038,0,0,1,3.033,3.035Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M56.155,74.063a2.5,2.5,0,0,0,2.5-2.5V51.316a2.5,2.5,0,0,0-5,0V71.563A2.5,2.5,0,0,0,56.155,74.063Z"
  })))));
}